<div mat-dialog-content>
  <div class="mat-dialog-header">
    <h3>Pedido de exame</h3>
  </div>
  <form class="form" [formGroup]="sadtModel" (ngSubmit)="onSubmit()">
    <div class="mat-dialog-content">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12">
          <mat-form-field appearance="outline">
            <mat-label>Local</mat-label>
            <mat-select (selectionChange)="onSelectPlaceExternal()" formControlName="idPlace">
              @for (item of listPlace; track item) {
                <mat-option [value]="item.idPlace">{{item.placeName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12">
          <mat-form-field appearance="outline">
            <mat-label>Tipo de Exame</mat-label>
            <mat-select (selectionChange)="onSelectExamType()" formControlName="idTypeSadt">
              @for (item of listExamTypeDisplay; track item) {
                <mat-option [value]="item.idExamType">
                  {{item.examTypeName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      @if (this.isInternal) {
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12">
            <mat-form-field appearance="outline">
              <mat-label>Horário</mat-label>
              <mat-select formControlName="idSadtSchedule">
                @for (item of listSadtSchedule; track item) {
                  <mat-option [value]="item.idSadtSchedule">{{item.sadtScheduleName}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }
      @if (this.idSadt != this.sadtOthers && listExamDisplay.length > 0) {
        <div class="row">
          @if (!this.data.readOnly) {
            <div class="col-9 col-sm-9 col-md-9">
              <app-select-2 [formControlField]="'idSadt'" [multiple]="true" [list]="listExamDisplay"
                [idField]="'idExam'" [nameField]="'examName'" [labelField]="'Exame'"
                [preSelectedlist]="this.listSelectedExamDisplay" (selectedValue)="selectedValue($event)">
              </app-select-2>
            </div>
          }
          @if (this.data.readOnly) {
            <div class="col-9 col-sm-9 col-md-9">
              <mat-form-field appearance="outline">
                <mat-label>Exame</mat-label>
                <textarea [disabled]="true" matInput [value]="this.allConcatSelectedExamNames"></textarea>
              </mat-form-field>
            </div>
          }
          <div class="col-3 col-sm-3 col-md-3">
            <div class="form-field-toggle">
              <mat-label>Todos</mat-label>
              <mat-slide-toggle [(ngModel)]="this.isAllExams" (change)="onToggleChange($event)"
                [ngModelOptions]="{standalone: true}"
              [disabled]="this.data && this.data.readOnly"></mat-slide-toggle>
            </div>
          </div>
        </div>
      }
      @if (this.idSadt == this.sadtOthers) {
        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>Descreva o exame</mat-label>
              <textarea [readonly]="this.data.readOnly" matInput formControlName="sadtDescription"></textarea>
            </mat-form-field>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>Observação Médica</mat-label>
            <textarea [readonly]="this.data.readOnly" matInput
            formControlName="observationMedic"></textarea>
          </mat-form-field>
        </div>
      </div>
      @if (this.data.readOnly) {
        <div class="row">
          <div class="col-6">
            <mat-form-field appearance="outline">
              <mat-label>Observação do exame</mat-label>
              <textarea [readonly]="this.data.readOnly" matInput formControlName="observation"></textarea>
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline">
              <mat-label>Resultado do exame</mat-label>
              <textarea [readonly]="this.data.readOnly" matInput formControlName="sadtResult"></textarea>
            </mat-form-field>
          </div>
        </div>
      }
      @if (medicalSadt && medicalSadt.idStatus == 2) {
        <div class="row">
          @for (item of medicalSadt.sadtResultFile; track item) {
            <div class="col-12" class="outline-spinner">
              <a (click)="downloadFile(item.idSadtResultFile)" class="download">
                <mat-icon>file_download</mat-icon> Ver arquivo {{item.sadtResultFileName}}
                @if (isLoading) {
                  <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
              </a>
            </div>
          }
        </div>
      }
      @if (this.idSadt != this.sadtOthers && allConcatSelectedSigtapNames) {
        <div class="row" style="margin-bottom: 15px; margin-top: -5px;">
          <div class="col-12">
            <div [matTooltip]="allConcatSelectedSigtapNames" matTooltipPosition="above" matTooltipClass="custom-tooltip"
              class="field-sigtap">
              <strong>Procedimento(s) SIGTAP Vinculado(s): </strong> {{ allConcatSelectedSigtapNames }}
            </div>
          </div>
        </div>
      }
      <div class="footer-panel-modal-list">
        <div class="row">
          <div class="col-6">
            @if (!this.data.readOnly) {
              <a mat-flat-button color="accent" class="btn-block"
              (click)="clickCancel()">Cancelar</a>
            }
          </div>
          @if (!this.data.readOnly) {
            <div class="col-6">
              <button mat-flat-button type="submit" color="primary" class=" btn-block">
                <span>Salvar</span>
              </button>
            </div>
          }
          <div class="col-12">
            @if (this.data.readOnly) {
              <a mat-flat-button color="primary" class="btn-block"
              (click)="clickCancel()">Ok</a>
            }
          </div>
        </div>
      </div>
    </div>
  </form>
</div>